import { Modal, Button } from "react-bootstrap";
import SystemNotification, { SystemNotificationButtonAction } from "./Model/SystemNotification";
import DOMPurify from 'dompurify';

interface ISystemNotificationModalProps {
    notification : SystemNotification;
    showModal : boolean;
    onNotificationAction : (notificationActionType : SystemNotificationButtonAction, notification: SystemNotification) => void;
}

export default function SystemNotificationModal(props : ISystemNotificationModalProps) {
    const {notification} = props;

    const onModalClose = () => props.onNotificationAction(SystemNotificationButtonAction.CloseAction, notification);
    const onPrimaryActionTaken = () => props.onNotificationAction(SystemNotificationButtonAction.PrimaryAction, notification);
    const onPermanentlyDismiss = () => props.onNotificationAction(SystemNotificationButtonAction.DontRemindMeAction, notification);

    return (<>
        {props.showModal && <Modal className="system-notification"
            show={props.showModal}
            onHide={onModalClose}
            backdrop="static"
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>{notification.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(notification.body)}}/>
            </Modal.Body>
            <Modal.Footer>
                <Button className="left-align" variant="outline-pp-primary" onClick={onPermanentlyDismiss}>
                    {notification.dontRemindButtonText}
                </Button>
                <Button variant="outline-pp-primary" onClick={onModalClose}>
                    {notification.closeButtonText}
                </Button>
                <Button variant="pp-primary" onClick={onPrimaryActionTaken}>{notification.primaryActionText}</Button>
            </Modal.Footer>
        </Modal>}
        </>);
}